module.exports = __webpack_public_path__ + "static/018-2b61d3f555c4c417924ec03a58551fca.jpg";